<template>
    <v-card :class="{'pa-3': $vuetify.breakpoint.xs, 'pa-5': $vuetify.breakpoint.smAndUp}">
        <v-icon class="modal-close" @click.native="CLOSE_MODAL('prize_recieved_modal')">close</v-icon>
        <v-card-title class="display-1 mb-4 text-xs-center d-block">{{$t("Приз получен")}}</v-card-title>
        <v-card-text class="title mt-4 text-xs-center">{{ chosen_prize.title }}</v-card-text>
        <v-layout mb-4 justify-center align-center class="mt-2">
            <div class="grey-text">{{$t("Баллов списано")}}:</div>
            <div class="headline ml-2">{{ chosen_prize.price }}</div>
        </v-layout>
        <v-card-actions>
            <v-layout align-center justify-center wrap>
                <buttonRed @click.native="close_modals()">OK</buttonRed>
            </v-layout>
        </v-card-actions>
    </v-card>
</template>

<script>
import buttonRed   from '@/components/ui/buttons/button_red';
import {mapGetters, mapMutations, mapActions} from 'vuex';

export default {
  components: {
    buttonRed,
  },
  data() {
    return {

    };
  },
  computed: {
    ...mapGetters('prize_shop', [
      'prizes_info_modal',
      'get_prize_modal',
      'prize_recieved_modal',
      'chosen_prize',
    ]),
  },
  methods: {
    ...mapMutations('prize_shop', [
      'CLOSE_MODAL',
      'OPEN_MODAL',
    ]),
    close_modals() {
      this.CLOSE_MODAL('prize_recieved_modal');
      this.CLOSE_MODAL('prizes_info_modal');
    },

  },


};
</script>
